import { type PropsWithChildren } from 'react';
import type { FieldValues, Resolver, SubmitHandler } from 'react-hook-form';
import { useForm, FormProvider } from 'react-hook-form';

import { LoadingContext } from './FormLoadingContext';
import { useScrollToErrorField } from './useScrollToErrorField';

interface FormWrapperProps extends PropsWithChildren {
  onSubmit: SubmitHandler<FieldValues>;
  loading?: boolean;
  values?: FieldValues;
  resolver?: Resolver;
}

export function FormWrapper({ children, onSubmit, loading = false, values, resolver }: FormWrapperProps) {
  const methods = useForm({ values, defaultValues: values, resolver, shouldFocusError: false, mode: 'onTouched' });

  useScrollToErrorField(methods.formState?.errors ?? {});

  return (
    <FormProvider {...methods}>
      <LoadingContext.Provider value={loading}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          {children}
          <input hidden type="submit" />
        </form>
      </LoadingContext.Provider>
    </FormProvider>
  );
}
